import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Check, Circle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const PASSWORD_RULES = [
  { id: 'length', label: 'At least 8 characters', test: p => p.length >= 8 },
  { id: 'upper', label: 'One uppercase letter (A-Z)', test: p => /[A-Z]/.test(p) },
  { id: 'lower', label: 'One lowercase letter (a-z)', test: p => /[a-z]/.test(p) },
  { id: 'number', label: 'One number (0-9)', test: p => /[0-9]/.test(p) },
  { id: 'special', label: 'One special character', test: p => /[!@#$%^&*(),.?":{}|<>]/.test(p) },
];

export default function RegisterPage() {
  const { register } = useAuth();
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await register(form.firstName, form.lastName, form.email, form.password);
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-page__container">
        <div className="auth-page__header">
          <h1 className="auth-page__brand">NOTCHED</h1>
          <p className="text-muted">Create your account.</p>
        </div>

        <div className="card">
          <h2 style={{ fontSize: '28px', marginBottom: '20px' }}>SIGN UP</h2>

          {error && (
            <div className="alert alert--error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form__row">
              <div className="form__group">
                <label>First Name</label>
                <input value={form.firstName} onChange={e => set('firstName', e.target.value)} placeholder="First" required />
              </div>
              <div className="form__group">
                <label>Last Name</label>
                <input value={form.lastName} onChange={e => set('lastName', e.target.value)} placeholder="Last" required />
              </div>
            </div>
            <div className="form__group">
              <label>Email</label>
              <input type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="you@email.com" required />
            </div>
            <div className="form__group">
              <label>Password</label>
              <input type="password" value={form.password} onChange={e => set('password', e.target.value)} placeholder="••••••••" required />
              {form.password && (
                <div style={{ marginTop: '8px' }}>
                  {PASSWORD_RULES.map(rule => (
                    <div key={rule.id} className={`pw-rule ${rule.test(form.password) ? 'pw-rule--pass' : 'pw-rule--fail'}`}>
                      <span className="pw-rule__icon">{rule.test(form.password) ? <Check size={12} /> : <Circle size={12} />}</span>
                      {rule.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <button type="submit" className="btn btn--primary btn--full" disabled={loading} style={{ marginTop: '8px' }}>
              {loading ? <span className="spinner" /> : 'CREATE ACCOUNT'}
            </button>
          </form>
        </div>

        <div className="auth-page__footer">
          Already have an account? <Link to="/login">Log in</Link>
        </div>
      </div>
    </div>
  );
}
